/**
 * WeekNavigation - Week selector for the Resource Planner toolbar.
 *
 * Renders previous/next arrows, the current week range and a "Hoy" shortcut.
 * Owns no state: the selected week lives in the orchestrator.
 */

interface WeekNavProps {
  weekStart: Date;
  onWeekChange: (date: Date) => void;
}

export function WeekNavigation({ weekStart, onWeekChange }: WeekNavProps) {
  const prevWeek = () => {
    const newDate = new Date(weekStart);
    newDate.setDate(newDate.getDate() - 7);
    onWeekChange(newDate);
  };

  const nextWeek = () => {
    const newDate = new Date(weekStart);
    newDate.setDate(newDate.getDate() + 7);
    onWeekChange(newDate);
  };

  const goToToday = () => {
    const today = new Date();
    const dayOfWeek = today.getDay();
    const monday = new Date(today);
    monday.setDate(today.getDate() - (dayOfWeek === 0 ? 6 : dayOfWeek - 1));
    onWeekChange(monday);
  };

  const weekEnd = new Date(weekStart);
  weekEnd.setDate(weekStart.getDate() + 6);

  return (
    <div className="flex items-center gap-4">
      <button
        onClick={prevWeek}
        className="p-2 rounded-lg hover:bg-surface-2 transition-colors"
      >
        ←
      </button>

      <div className="text-center min-w-[200px]">
        <p className="font-semibold text-ink">
          {weekStart.toLocaleDateString('es-ES', { day: 'numeric', month: 'short' })}
          {' - '}
          {weekEnd.toLocaleDateString('es-ES', { day: 'numeric', month: 'short', year: 'numeric' })}
        </p>
      </div>

      <button
        onClick={nextWeek}
        className="p-2 rounded-lg hover:bg-surface-2 transition-colors"
      >
        →
      </button>

      <button
        onClick={goToToday}
        className="px-3 py-1 text-sm bg-info-soft text-info rounded-lg hover:bg-info-soft transition-colors"
      >
        Hoy
      </button>
    </div>
  );
}
